<template>
	<div class="accordion" :class="{ closed: !show }">
		<div class="accordion__title" @click="show = !show">
			{{ title }}
			<img src="/img/frontend/calc/icon/chevron-up.svg" v-if="show" alt="" />
			<img src="/img/frontend/calc/icon/chevron-down.svg" v-else alt="" />
		</div>
		<div class="accordion__body" v-show="show">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	mounted() {
		this.show = this.baseShow;
	},
	data() {
		return {
			show: false,
		};
	},
	props: {
		title: {
			type: String,
			default: null,
		},
		baseShow: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.accordion {
	&.closed {
		border-bottom: 1px solid #c4c4c4;
	}

	&__title {
		font-family: Arial;
		font-style: normal;
		font-weight: bold;
		font-size: 24px;
		line-height: 24px;
		color: #6a7178;
		padding: 10px 20px;
		position: relative;
		cursor: pointer;

		img {
			position: absolute;
			right: 20px;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	&__body {
		background: rgba(237, 251, 255, 0.5);
		border-radius: 3px 3px 0px 0px;
		color: #6a7178;
		padding: 30px 15px;
	}
}
</style>
